import assert from 'assert';
import { Device, Grid, Loading, Theme } from '@livecontrol/core-ui';
import { Enum, Str } from '@livecontrol/core-utils';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import { useUntitledEvent } from '../graphql';
import { AssetDetailsSummary } from './asset-details-summary';
import { OperatorNotes } from './operator-notes';
import { Player } from './spotlight';
import { Tab, Tabber } from './tabber';
// import Phase = Event.Phase;

export const AssetDetailsLayout = (): React.ReactElement => {
  const viewport = Theme.useViewport();
  const isDesktop = Device.isDesktop(viewport);
  const eid = Str.normalize(useParams<{ eid: string }>().eid);
  const [tab, setTab] = useState<Tab.OperatorNotes>(Tab.OperatorNotes);

  assert(typeof eid === 'string');

  const { loading, untitledEvent } = useUntitledEvent(eid);

  const TabContentMap = {
    [Tab.OperatorNotes]: untitledEvent && <OperatorNotes untitledEvent={untitledEvent} />
  };

  const tabContent = TabContentMap[tab];

  return loading ? (
    <Loading isOldVersion={true} />
  ) : untitledEvent ? (
    <Grid
      gridTemplateColumns={isDesktop ? '375px 1fr' : '1fr'}
      gridTemplateAreas={
        isDesktop
          ? `
          "spotlight details"
          "tabs tabs"
        `
          : `
          "spotlight"
          "details"
          "tabs"
        `
      }
      columnGap='3rem'
      rowGap='1rem'
    >
      <Grid.Item gridArea='spotlight'>
        <Player untitledEvent={untitledEvent} />
      </Grid.Item>
      <Grid.Item gridArea='details'>
        <AssetDetailsSummary untitledEvent={untitledEvent} />
      </Grid.Item>
      <Grid.Item gridArea='tabs'>
        <Tabber
          tab={tab}
          onSelect={(key): void => {
            setTab(Enum.normalize(Tab, key)!);
          }}
        />
        {tabContent}
      </Grid.Item>
    </Grid>
  ) : (
    <div className='text-white'>Could not load event details</div>
  );
};
